import api from './api'

const medicalCodingService = {
  // Get all medical coding records
  getAllCoding: (params) => api.get('/mrd/coding', { params }),

  // Get medical coding by ID
  getCodingById: (id) => api.get(`/mrd/coding/${id}`),

  // Get medical coding for a specific file
  getCodingByFile: (fileId) => api.get(`/mrd/coding/file/${fileId}`),

  // Create or update medical coding
  createUpdateCoding: (fileId, data) => api.post(`/mrd/coding/${fileId}`, data),

  // Verify medical coding
  verifyCoding: (codingId, data) => api.post(`/mrd/coding/verify/${codingId}`, data),

  // Search ICD codes
  searchICDCodes: (params) => {
    // Map the parameters to match the ICD controller expectations
    const searchParams = {
      q: params.query,
      limit: params.limit,
      icdVersion: params.version === 'ICD10' ? 'ICD-10' : 
                  params.version === 'ICD11' ? 'ICD-11' : 
                  params.version === 'ICD10-PCS' ? 'ICD-10-PCS' : params.version
    }
    return api.get('/master/icd/search/global', { params: searchParams })
  },

  // Get ICD code details
  getICDCodeDetails: (code) => api.get(`/mrd/coding/icd/${code}`),

  // Auto-suggest ICD codes
  autoSuggestICDCodes: (data) => api.post('/mrd/coding/auto-suggest', data),

  // Map ICD-10 to ICD-11
  mapICD10ToICD11: (icd10Code) => api.get(`/mrd/coding/map/${icd10Code}`),

  // Calculate DRG
  calculateDRG: (data) => api.post('/mrd/coding/calculate-drg', data),

  // Get coding statistics
  getCodingStatistics: (params) => api.get('/mrd/coding/stats/summary', { params }),

  // Get coding dashboard
  getCodingDashboard: () => api.get('/mrd/coding/dashboard/data'),

  // Get coding audit trail
  getCodingAuditTrail: (codingId) => api.get(`/mrd/coding/audit/${codingId}`),

  // Create coding revision
  createCodingRevision: (codingId, data) => api.post(`/mrd/coding/${codingId}/revision`, data),

  // Get coding versions
  getCodingVersions: (codingId) => api.get(`/mrd/coding/${codingId}/versions`),

  // Delete medical coding
  deleteCoding: (id) => api.delete(`/mrd/coding/${id}`),

  // Bulk import coding
  bulkImportCoding: (data) => api.post('/mrd/coding/bulk-import', data)
}

export default medicalCodingService
